module.exports = __webpack_public_path__ + "img/19.ca4e9b42.png";